// @flow

import styled from 'styled-components';
import { clearfix } from 'styles/Mixins';

export const CloseButton = styled.div`
  color: ${props => (props.tColor ? '#278C7E' : '#FFFFFF')};
  float: right;
  font-size: 36px;
  cursor: pointer;
`;

export const Modal = styled.div`
  ${clearfix}
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  overflow-x: ${({ overflow = true }) => (overflow ? 'hidden' : '')};
  overflow-y: ${({ overflow = true }) => (overflow ? 'auto' : '')};
  outline: 0;
  display: ${props => (props.show ? 'block' : 'none')};
`;

export const ModalBody = styled.div`
  position: relative;
  padding: 3px 14px;
`;
export const ModalTitle = styled.div`
  color: #4a4a4a;
  font-size: 16px;
  margin-bottom: 20px;
`;

export const ModalCard = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: calc(100% - 12px);
  max-width: 346px;
  border-radius: 2px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transform: translate(-50%, -50%);
`;

export const ModalCardTitle = styled.span`
  display: block;
  width: 100%;
  color: #4a4a4a;
  font-size: 18px;
  min-height: 22px;
  line-height: 22px;
  text-align: center;
`;

export const ModalCardDescription = styled.span`
  display: block;
  width: 100%;
  color: #4a4a4a;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
`;

export const ScreenOverlay = styled(Modal)`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const StyledScreenOverlay = styled(ScreenOverlay)`
  display: ${props => (props.show ? 'table' : 'none')};
`;

export const StyledContentScreen = styled.div`
  display: table-cell;
  vertical-align: middle;
`;

export const StyledModalContent = styled(ModalBody)`
  height: ${props =>
    props.contentHeight ? props.contentHeight : 'auto !important'};
  margin: 0 auto;
  width: ${props => (props.contentWidth ? props.contentWidth : 720)}px;
  border-radius: 2px;
  padding: ${props => props.pTop || 0};
  background-color: ${props => props.bColor || '#FFFFFF'};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  padding-bottom: 10px;
`;

export const StyledModalHead = styled.div`
  padding: ${props => (props.paddng ? props.paddng : 15)}px;
`;

export const StyledModalTitle = styled(ModalTitle)`
  font-weight: bold;
`;

export const StyledModalBody = styled.div`
  position: relative;
  padding: 0 20px;
  line-height: 1;
`;

export const StyledContent = styled.div`
  color: #4a4a4a;
  font-size: 16px;
  margin-bottom: 10px;
`;

export const StyledStubSentScreen = styled.div`
  padding-top 9%;
`;
